module.exports = __webpack_public_path__ + "static/media/leftArrow.c17c1fe4.svg";